(function () {
  // 1. Safety Check
  if (typeof gsap === "undefined") {
    console.error("GSAP not loaded.");
    return;
  }

  if (typeof ScrollTrigger === "undefined") {
    console.error("ScrollTrigger not loaded.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // ==================================================
  // FUNCTION: Handle Sticky Scroll Logic
  // ==================================================
  function runStickyScrollLogic(context) {
    const stickySections = context.querySelectorAll(".sticky-scroll-wrapper");

    stickySections.forEach((section) => {
      const container = section.querySelector(".sticky-scroll__container");
      const stickyBox = section.querySelector(".sticky-box");
      const boxes = Array.from(section.querySelectorAll(".content-box"));
      const images = Array.from(section.querySelectorAll(".sticky-scroll__image"));

      if (!container || !stickyBox || !boxes.length || !images.length) return;

      let currentActive = -1;

      function setActive(index) {
        const i = Math.max(0, Math.min(index, Math.min(boxes.length, images.length) - 1));
        if (i === currentActive) return;

        currentActive = i;

        boxes.forEach((box, idx) => box.classList.toggle("is-active", idx === i));
        images.forEach((img, idx) => img.classList.toggle("is-active", idx === i));
      }

      setActive(0);

      const mm = gsap.matchMedia();

      mm.add("(min-width: 1200px)", () => {
        ScrollTrigger.create({
          trigger: stickyBox,
          start: "top 9%",
          endTrigger: container,
          end: "bottom 160%",
          pin: true,
          pinSpacing: false,
          invalidateOnRefresh: true,
        });

        const points = [0.35, 0.55, 0.75];

        function nearestIndex(progress) {
          const n = Math.min(points.length, boxes.length, images.length);
          let bestIdx = 0;
          let bestDist = Infinity;

          for (let i = 0; i < n; i++) {
            const d = Math.abs(progress - points[i]);
            if (d < bestDist) {
              bestDist = d;
              bestIdx = i;
            }
          }
          return bestIdx;
        }

        ScrollTrigger.create({
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          onUpdate: (self) => {
            setActive(nearestIndex(self.progress));
          },
          invalidateOnRefresh: true,
        });
      });
    });
  }

  // ==================================================
  // FUNCTION: Main GSAP Initialization (ULTRA SMOOTH)
  // ==================================================
  function initGSAPAnimations(context = document) {
    ScrollTrigger.getAll().forEach((st) => st.kill());

    // ==================================================
    // UPDATED ONLY: fade-up / fade-left / fade-right + animate-group
    // (Everything else remains the same)
    // ==================================================
    const animateElement = (el, delay = 0, trigger = null) => {
      let startX = 0,
        startY = 0;
      if (el.classList.contains("fade-left")) startX = -40;
      if (el.classList.contains("fade-right")) startX = 40;
      if (el.classList.contains("fade-up")) startY = 40;

      // Dynamic Duration Logic
      let attrDuration = el.getAttribute("data-duration");
      let animDuration = attrDuration ? parseFloat(attrDuration) : 1.5;
      if (isNaN(animDuration)) animDuration = 1.5;

      // Stable compositing during animation (reduces jitter/shake)
      gsap.set(el, {
        willChange: "transform,opacity",
        force3D: true,
        backfaceVisibility: "hidden",
      });

      gsap.fromTo(
        el,
        { autoAlpha: 0, x: startX, y: startY },
        {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: animDuration,
          ease: "power2.out",
          delay,
          force3D: true,
          overwrite: "auto",
          immediateRender: false, // prevents first-frame jump
          onComplete: () => gsap.set(el, { willChange: "auto" }),
          scrollTrigger: {
            trigger: trigger || el,
            start: "top 85%",
            once: true,
            invalidateOnRefresh: true,
          },
        }
      );
    };

    // 1. Group Animations
    gsap.utils.toArray(context.querySelectorAll(".animate-group")).forEach((group) => {
      const items = group.querySelectorAll(".fade-up, .fade-left, .fade-right");
      items.forEach((el, i) => {
        animateElement(el, i * 0.2, group);
      });
    });

    // 2. Single Elements
    gsap.utils
      .toArray(
        context.querySelectorAll(
          ".fade-up:not(.animate-group .fade-up), .fade-left:not(.animate-group .fade-left), .fade-right:not(.animate-group .fade-right)"
        )
      )
      .forEach((el) => {
        animateElement(el, 0, null);
      });

    // --- Run Sticky Logic ---
    runStickyScrollLogic(context);

    ScrollTrigger.refresh();
  }

  // ==================================================
  // LOGIC CONTROL: Preloader & Timing
  // ==================================================
  document.addEventListener("DOMContentLoaded", function () {
    const preloader = document.getElementById("gsap-preloader");

    if (preloader) {
      // HOME PAGE
      document.body.classList.add("is-loading");

      window.addEventListener("load", () => {
        gsap.to(preloader, {
          opacity: 0,
          duration: 0.6,
          delay: 0.2,
          onComplete: () => {
            preloader.style.display = "none";
            document.body.classList.remove("is-loading");

            setTimeout(() => {
              initGSAPAnimations();
            }, 200);
          },
        });
      });
    } else {
      // INNER PAGE
      window.addEventListener("load", () => {
        initGSAPAnimations();
      });
    }
  });

  document.addEventListener("shopify:section:load", (e) => initGSAPAnimations(e.target));
})();